import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
import { useWorkflowStores } from "@/composables/workflowStores";
import FormElement from "@/components/Form/FormElement.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormOutputLabel',
    props: {
        name: null,
        step: null,
        showDetails: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const { stepStore } = useWorkflowStores();
        const error = ref(undefined);
        const id = computed(() => `__label__${props.name}`);
        const title = computed(() => (props.showDetails ? `Label for: '${props.name}'` : "Label"));
        const label = computed(() => {
            var _a;
            if ((_a = props.step.workflow_outputs) === null || _a === void 0 ? void 0 : _a.length) {
                const workflowOutput = props.step.workflow_outputs.find((workflowOutput) => workflowOutput.output_name === props.name);
                if (workflowOutput) {
                    return workflowOutput.label;
                }
            }
            return null;
        });
        function onInput(newLabel) {
            if (newLabel === undefined || newLabel === null) {
                // form got activated or we set a workflow output through the checkbox
                // shouldn't change status of error label or result in deleting the label
                return;
            }
            if (newLabel === "") {
                // user deleted existing label, we inactivate this as output
                const strippedWorkflowOutputs = (props.step.workflow_outputs || []).filter((workflowOutput) => workflowOutput.output_name !== props.name);
                stepStore.updateStep(Object.assign(Object.assign({}, props.step), { workflow_outputs: strippedWorkflowOutputs }));
                error.value = undefined;
                return;
            }
            const existingWorkflowOutput = stepStore.workflowOutputs[newLabel];
            if (!existingWorkflowOutput) {
                // got a new label that isn't in use yet
                const newWorkflowOutputs = [...(props.step.workflow_outputs || [])].filter((workflowOutput) => workflowOutput.output_name !== props.name);
                newWorkflowOutputs.push({
                    label: newLabel,
                    output_name: props.name,
                });
                stepStore.updateStep(Object.assign(Object.assign({}, props.step), { workflow_outputs: newWorkflowOutputs }));
                error.value = undefined;
            }
            else if (existingWorkflowOutput.stepId !== props.step.id) {
                error.value = `Duplicate output label '${newLabel}' will be ignored.`;
            }
        }
        return { __sfc: true, props, stepStore, error, id, title, label, onInput, FormElement };
    }
});
